import ProductModel from "@src/backbone/model/ProductModel";
import TrackAddToCart, { TrackAddToCartOptions } from "./TrackAddToCart";
import { EPriceType } from "@src/backbone/model/StoreModel";

export const TrackAddToCartModel = (
  productModel: ProductModel,
  quantity: number = 1
) => {
  const productOptions: TrackAddToCartOptions = {
    product_id: productModel.getId(),
    product_sku: productModel.get("reference") || "",
    product_quantity: quantity,
    product_variant: "",
    product_brand: "Sushishop",
    product_name: productModel.get("name") || "",
    product_category_1: productModel.getCategoryDefault()?.getName() || "",
    product_category_2: productModel.getCategories()?.at(1)?.getName() || "",
    product_category_3: productModel.getCategories()?.at(2)?.getName() || "",
    product_unitprice_ati: productModel.getPrice(EPriceType.TTC) || 0,
    product_unitprice_tf: productModel.getPrice(EPriceType.HT) || 0,
  };
  TrackAddToCart(productOptions);
};
